export default {
  name: 'business-service',
  translationKey: 'business-service-module',
  routePrefix: 'business-service',
  routeNamePrefix: 'business-service',
  directRoutesAvailable: false,
}
